/** 숫자·날짜 포맷 유틸 */

/**
 * 금액을 억/조 한국어 단위로 포맷.
 * @param value 금액 (기본: 원 단위)
 * @param options.fromWon true면 원 단위 입력으로 보고 억으로 환산(기본 true). false면 이미 억 단위 입력.
 * @param options.naOnFalsy true면 0/null/NaN 등 falsy 값을 "N/A"로 표시.
 */
export function formatEokJo(
  value: number | null,
  options: { fromWon?: boolean; naOnFalsy?: boolean } = {}
): string {
  const { fromWon = true, naOnFalsy = false } = options;
  if (value == null) return "N/A";
  if (naOnFalsy && !value) return "N/A";
  const eok = fromWon ? value / 1e8 : value;
  if (Math.abs(eok) >= 10000) return `${(eok / 10000).toFixed(1)}조`;
  return `${Math.round(eok).toLocaleString()}억`;
}

/** 원 단위 금액에 천단위 콤마 + "원" (falsy → "N/A") */
export function formatWon(value: number | null): string {
  if (!value) return "N/A";
  return `${value.toLocaleString()}원`;
}

/** 주가를 만 단위로 축약 (차트 축용). 1만 미만은 콤마 표기 */
export function formatPriceShort(value: number): string {
  return value >= 10000 ? `${(value / 10000).toFixed(1)}만` : value.toLocaleString();
}

/** 거래량을 M/K 단위로 축약 */
export function formatVolume(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K`;
  return String(value);
}

/** "YYYY-MM-DD" → "YY.MM" */
export function formatYearMonth(dateStr: string): string {
  const [y, m] = dateStr.split("-");
  return `${y.slice(2)}.${m}`;
}

/** ISO 시각 → 상대 시간 ("방금 전", "5분 전", ...) */
export function timeAgo(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return "방금 전";
  if (min < 60) return `${min}분 전`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}시간 전`;
  const day = Math.floor(hr / 24);
  return `${day}일 전`;
}
